import createBrowserFlushSignal from 'src/internal/common/createBrowserFlushSignal';
import createBatchingMetricsTransport from 'src/internal/metrics/transport/createBatchingMetricsTransport';
import createBrowserFetch from 'src/internal/transport/createBrowserFetch';

import type {
  MetricsTransport,
  MetricsTransportConfig,
} from 'src/internal/metrics/types';
import type {ServiceName} from 'src/types';

const transportsMap: Partial<Record<ServiceName, MetricsTransport>> = {};

function createMetricsTransport(
  service: ServiceName,
  partialConfig: Partial<MetricsTransportConfig>,
): MetricsTransport {
  const config = {
    fetch: partialConfig.fetch ?? createBrowserFetch(),
    service,
    useAelMetricsEndpoint: partialConfig.useAelMetricsEndpoint ?? false,
    flushSignal: partialConfig.flushSignal ?? createBrowserFlushSignal(),
  };

  return createBatchingMetricsTransport(config);
}

/**
 * Returns a metrics transport for the given service.
 * If the transport is not already created, it creates a new one and returns it.
 */
export default function getMetricsTransport(
  service: ServiceName,
  config: Partial<MetricsTransportConfig>,
): MetricsTransport {
  if (!transportsMap[service]) {
    transportsMap[service] = createMetricsTransport(service, config);
  }

  return transportsMap[service];
}
